import { useFormikContext } from 'formik';
import { DatePicker, ErrorContainer, LabelComponent } from 'components';
import dayjs from 'dayjs';

interface NextContactProps {
  disabled: boolean;
}

export const NextContact = ({ disabled }: NextContactProps) => {
  const formik = useFormikContext<{
    nextContact: string;
    dateOfEncounter: string;
  }>();

  return (
    <>
      <LabelComponent text="Next Contact" />
      <DatePicker
        withGradient
        onChange={(date: string) => {
          formik.setFieldValue('nextContact', date).then(() => {
            formik.setFieldTouched('nextContact', true);
          });
        }}
        onBlur={() => formik.setFieldTouched('nextContact', true)}
        value={formik.values.nextContact}
        placeholder="MM/DD/YYYY"
        minDate={
          formik.values.dateOfEncounter != null && formik.values.dateOfEncounter !== ''
            ? dayjs(formik.values.dateOfEncounter).add(1, 'day')
            : undefined
        }
        disablePast={false}
        disabled={disabled}
      />
      <ErrorContainer
        visible={formik.touched?.nextContact && (formik.errors?.nextContact as string)}
        errors={formik.errors}
        name="nextContact"
      />
    </>
  );
};
